import { Outlet } from 'react-router-dom';
import { SkinSessionProvider } from '../../salon/context/SkinSessionContext';
import { OrgPlanProvider } from '../context/OrgPlanContext';
import { MakeupHairNavProvider } from '../context/MakeupHairNavContext';
import MakeupHairAppHeader from './MakeupHairAppHeader';
import SalonLandingBackground, {
  KIOSK_PAGE_KEYS,
} from '../../salon/components/SalonLandingBackground';
import { PageBackgroundSync } from '../../salon/components/PageBackgroundSync';
import PageFooter from '../../salon/components/PageFooter';
import { BeautyProductProvider } from '../../../beauty-shared/context/BeautyProductContext';
import { BEAUTY_PRODUCTS } from '../../../beauty-shared/config/saasModules';
import { resolveAnalysisFlowHomePath } from '../../salon/utils/salonHomeNav';
import '../../salon/components/SalonLandingBackground.css';
import '../../shared/EnterpriseKioskTabletFooter.css';
import '../styles/CommonBackground.css';
import ModernDialogHost from '../../admin-shared/ModernDialogHost';

const NYAFAZ_EP_MAKEUP_APP_BASE = '/nyafaz-ep/makeup';

const NYAFAZ_EP_BEAUTY_APP_BASE = {
  [BEAUTY_PRODUCTS.makeupStudioTest.moduleId]: NYAFAZ_EP_MAKEUP_APP_BASE,
  [BEAUTY_PRODUCTS.hairStyling.moduleId]: '/nyafaz-ep/hair-styling',
  [BEAUTY_PRODUCTS.hairColoring.moduleId]: '/nyafaz-ep/hair-coloring',
  [BEAUTY_PRODUCTS.makeup.moduleId]: NYAFAZ_EP_MAKEUP_APP_BASE,
  [BEAUTY_PRODUCTS.looks.moduleId]: NYAFAZ_EP_MAKEUP_APP_BASE,
};

function resolveNyafazEpBeautyAppBase(product) {
  const cfg = product || BEAUTY_PRODUCTS.makeup;
  if (cfg.moduleId && NYAFAZ_EP_BEAUTY_APP_BASE[cfg.moduleId]) {
    return NYAFAZ_EP_BEAUTY_APP_BASE[cfg.moduleId];
  }
  const enterpriseBase = String(cfg.enterpriseAppBase || '').replace('/enterprise/', '/nyafaz-ep/');
  if (enterpriseBase.startsWith('/nyafaz-ep/')) return enterpriseBase.replace(/\/$/, '');
  return NYAFAZ_EP_MAKEUP_APP_BASE;
}

export default function MakeupHairAuthLayout({
  product = BEAUTY_PRODUCTS.makeup,
  naturals = true,
  nyafazEp = false,
}) {
  const appBaseOverride = nyafazEp ? resolveNyafazEpBeautyAppBase(product) : undefined;
  const hubPathOverride = nyafazEp ? resolveAnalysisFlowHomePath() : undefined;

  return (
    <BeautyProductProvider
      product={product}
      naturals={naturals && !nyafazEp}
      appBaseOverride={appBaseOverride}
      hubPathOverride={hubPathOverride}
    >
      <SkinSessionProvider>
        <OrgPlanProvider>
          <MakeupHairNavProvider>
            <PageBackgroundSync />
            <div className="naturals-makeup-landing-shell naturals-salon-lux fi-lux-theme">
              <SalonLandingBackground pageKey={KIOSK_PAGE_KEYS.SALON_ENTRY} source="pageSetup" />
              <div className="naturals-makeup-landing-shell__content naturals-salon-lux__content">
                <MakeupHairAppHeader />
                <Outlet />
                <PageFooter />
              </div>
              <ModernDialogHost />
            </div>
          </MakeupHairNavProvider>
        </OrgPlanProvider>
      </SkinSessionProvider>
    </BeautyProductProvider>
  );
}
